import { COUNTRY_STATES, COUNTRY_POSTAL_CODE_REGEX } from '../constants/geolocalization';

export const getPostalCodeRegex = (countryCode) => {
  const { [countryCode]: countryRegex, US: defaultRegex } = COUNTRY_POSTAL_CODE_REGEX;

  return countryRegex || defaultRegex;
};

export const getCountryStates = (countryCode) => COUNTRY_STATES[countryCode] || COUNTRY_STATES.US;

export const formatCAPostalCode = (postalCode) => {
  if (postalCode.length !== 6) return postalCode;
  if (postalCode[3] === ' ') return postalCode;
  return `${postalCode.slice(0, 3)} ${postalCode.slice(3, 6)}`;
};
